export const one = { type: "cn", idx: 2, children: ["1"], attributes: { type: "integer" } };
export const zero = { type: "cn", idx: 2, children: ["0"], attributes: { type: "integer" } };
